import UserProfile from '../components/UserProfile'
import { userProfileServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const UserProfileWidget = injectWidget({
  widget: UserProfile,
  serviceConfig: userProfileServiceConfig,
})

export default UserProfileWidget
